import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import type { InfinitySelectOption } from "~components/InfinitySelect";
import { SelectSeries } from "~components/SelectSeries/SelectSeries";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties, FixtureTransformed } from "../../types";

interface ISeriesColumnProperties extends ColumnComponentProperties {
  fixture: FixtureTransformed;
}

export const SeriesColumn = (properties: ISeriesColumnProperties) => {
  const { formatMessage } = useIntl();
  const { mutate: updateFixture, isPending: isLoading } = useUpdateListFixture();

  if (properties.editMode) {
    const value = isEmpty(properties.fixture.series)
      ? null
      : {
          label: properties.fixture.series.nameLocal,
          value: properties.fixture.series.seriesCode,
        };

    const onChangeHandler = (seriesOption: InfinitySelectOption | null) =>
      updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          seriesCode: seriesOption?.value ? seriesOption?.value : null,
        },
        oldSeriesCode: properties.fixture?.series?.seriesCode ?? null,
      });

    return (
      <SelectSeries
        disabled={isLoading}
        placeholder={formatMessage({
          id: "fixtureListPage.table.column.editMode.series.placeholder",
        })}
        value={value}
        onChange={onChangeHandler}
        stageCode={properties.fixture?.stage?.stageCode}
      />
    );
  }

  return properties.fixture.series?.nameLocal;
};
